module.exports = __webpack_public_path__ + "img/eclipse.b6a89228.gif";